import {
  SET_STORE_DELIVERY_ZONE_DESCRIPTION,
  SET_STORE_CUSTOMER_DEFAULT_ADDRESS,
  SET_STORE_CUSTOMER_ADDRESSLIST,
  SET_STORE_DELIVERYZONEID,
  SET_STORE_CUSTOMER_NAME,
  SET_STORE_PAGE_URL,
  SET_STORE_PHONE_NO,
  SET_STORE_ZONEID,
  SET_STORE_CSID,
} from "../../database/store-data";
import {
  STORE_FAVOURITE_MERCHANT_LIST,
  STORE_ISFORCE_TO_SIGN_OUT,
  TEMP_STORE_CustomerName,
  STORE_AUTO_PLACE_ORDER,
  STORE_AUTO_PLACE_PAYMODE,
  STORE_AUTO_PLACE_BANK_GUID,
  STORE_RATING_POSID,
  TEMP_STORE_PhoneNo,
  STORE_PROMO_DATA,
  TEMP_STORE_CSID,
  STORE_PAGE_URL,
  TEMP_STORE_OTP,
  ENTRY_MODE,
  STORE_DineType,
} from "../../database/store-names";
import {
  api_LoadCustomerWiseMerchantFavouriteListToMemory,
  api_GetCustomerDeliveryAddress,
  api_CheckMobilePhoneNumber,
  api_UpdateExpoPushToken,
  api_VarifyCustomerOTP,
  api_SendOtp,
} from "../../connection/api/api-profile";
import {
  Temp_Get_CustomerPhoneNO,
  GET_SET_STORED_DATA,
  GET_PAGE_URL,
} from "../../database/get-stored-data";
import {
  dto_CustomerAddressList,
  dto_CustomerAddress,
  dto_Customer,
} from "../../classes/dto-customer";
import {
  PT_ADDRESSLIST,
  PT_PROFILE,
  PT_SIGNIN,
} from "../../routes/stack/paths/pt-profile";
import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { placeOrderFromStoredCheckout } from "../../functions/place-order";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { PT_CART, PT_PAYMODE } from "../../routes/stack/paths/pt-cart";
import { api_LoadAllPromo } from "../../connection/api/api-cart";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_common } from "../../classes/dto-common";
import { PT_ORDERS } from "../../routes/stack/paths/pt-orders";
import { Colors } from "../../util/colors";
import React from "react";
import "../../styles/css/pg-profile-otp.css";

export default class OTP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: {},
      seconds: 180,
      PhoneNumber: 0,
      isLoading: false,
      otp: ["", "", "", ""],
    };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({
      time: timeLeftVar,
      PhoneNumber: await Temp_Get_CustomerPhoneNO(),
    });
    this.startTimer();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "OTP",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_SIGNIN);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
    if (CSP === "DT" && ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR") {
      const headerTitle = document.getElementById("HeaderTabName");
      if (headerTitle) {
        headerTitle.style.textAlign = "center";
        headerTitle.style.paddingLeft = "0";
        headerTitle.style.paddingRight = "0";
      }
    }
    setTimeout(() => {
      const otpInput = document.getElementById("OTPSubmit");
      if (otpInput) {
        otpInput.focus();
      }
    }, 0);
  }

  async ReSendOTP(Phone) {
    await api_SendOtp(Phone);
    this.setState({ update: 0 });
    window.location.reload();
  }

  async SubmitOTP() {
    var InputOTP = document.getElementById("OTPSubmit").value;
    this.setState({ isLoading: true });

    //var DBOTP = dto_Customer.OTPCode;
    let TmpCSID = ENCRYPT_STORAGE.getItem(TEMP_STORE_CSID);
    let IsOTPVeryfied = await api_VarifyCustomerOTP(TmpCSID, InputOTP);
    let RsIsOTPVeryfied = JSON.parse(IsOTPVeryfied);
    if ("SUCCESS" === RsIsOTPVeryfied) {
      let data = await api_CheckMobilePhoneNumber(
        await Temp_Get_CustomerPhoneNO(),
      );
      let objData = JSON.parse(data);
      let objobjData = JSON.parse(objData);
      if (objobjData[0][0].CSID > 0) {
        dto_Customer.CSID = objobjData[0][0].CSID;
        dto_Customer.CusName = objobjData[0][0].CusName;
        dto_Customer.Email = objobjData[0][0].Email;
        dto_Customer.PhoneNo = objobjData[0][0].PhoneNo;
        this.setState({ UPDATE: 0 });
        ENCRYPT_STORAGE.removeItem(TEMP_STORE_CSID);
        ENCRYPT_STORAGE.removeItem(TEMP_STORE_CustomerName);
        ENCRYPT_STORAGE.removeItem(TEMP_STORE_PhoneNo);
        ENCRYPT_STORAGE.removeItem(TEMP_STORE_OTP);
        SET_STORE_CSID(dto_Customer.CSID);
        SET_STORE_CUSTOMER_NAME(dto_Customer.CusName);
        SET_STORE_PHONE_NO(dto_Customer.PhoneNo);
      }

      // TO save the pending pending POSID in the memory
      let response = await api_UpdateExpoPushToken();
      let objResponse = JSON.parse(response);
      let finalObjResponse = JSON.parse(objResponse);
      let PendingRatePOSID = finalObjResponse[0].POSID;
      let IsforcedtoSignOut = finalObjResponse[0].IsForcedToSignout;

      //updating the PendingRatePOSID
      ENCRYPT_STORAGE.setItem(STORE_RATING_POSID, PendingRatePOSID);

      //updating the isForcedToSignOut boolean
      ENCRYPT_STORAGE.setItem(STORE_ISFORCE_TO_SIGN_OUT, IsforcedtoSignOut);

      // To save the promos in the memory
      if (CSP === "AV") {
        let promoDtaa = await api_LoadAllPromo(0);
        if (promoDtaa !== '"[[]]"') {
          let d = JSON.parse(promoDtaa);
          let oobjData = JSON.parse(d);
          ENCRYPT_STORAGE.setItem(STORE_PROMO_DATA, oobjData);
        }

        //GET Favourite merchants for customer
        let Fav = await api_LoadCustomerWiseMerchantFavouriteListToMemory();
        let parseFav = JSON.parse(Fav);
        let parseFavObj = JSON.parse(parseFav);
        if (parseFav !== "[[]]") {
          let finalfaouriteMerchantList = parseFavObj[0];
          ENCRYPT_STORAGE.setItem(
            STORE_FAVOURITE_MERCHANT_LIST,
            finalfaouriteMerchantList,
          );
        }
      }

      let dataAddress = await api_GetCustomerDeliveryAddress();
      let objDataAddress = JSON.parse(dataAddress);
      let objobjDataAddress = JSON.parse(objDataAddress);
      if (objobjDataAddress[0].length > 0) {
        for (let i = 0; i < objobjDataAddress[0].length; i++) {
          if (objobjDataAddress[0][i].Add1 !== "") {
            if (objobjDataAddress[0][i].IsDefault === true) {
              dto_CustomerAddress.AddressGuid = objobjDataAddress[0][i].GUID;
              dto_CustomerAddress.DefaultAdd1 = objobjDataAddress[0][i].Add1;
              dto_CustomerAddress.DefaultAdd2 = objobjDataAddress[0][i].Add2;
              dto_CustomerAddress.DefaultAdd3 = objobjDataAddress[0][i].Add3;
              dto_CustomerAddress.Location = objobjDataAddress[0][i].Location;
              dto_common.ZoneDescription = objobjDataAddress[0][i].ZoneDesc;

              await SET_STORE_CUSTOMER_DEFAULT_ADDRESS();
              if (CSP !== "AV") {
                dto_common.ZoneId = objobjDataAddress[0][i].DeliveryZoneID;
                await SET_STORE_ZONEID(objobjDataAddress[0][i].DeliveryZoneID);
                await SET_STORE_DELIVERY_ZONE_DESCRIPTION(
                  objobjDataAddress[0][i].ZoneDesc,
                );
              }
              dto_common.DeliveryZoneID =
                objobjDataAddress[0][i].DeliveryZoneID;
              await SET_STORE_DELIVERYZONEID(
                objobjDataAddress[0][i].DeliveryZoneID,
              );
            }
          }
        }
        dto_CustomerAddressList.dtoAddressList = objobjDataAddress[0];
        this.setState({ done: 1 });
        await SET_STORE_CUSTOMER_ADDRESSLIST();
        if (
          dto_common.DeliveryZoneID === "" ||
          dto_common.DeliveryZoneID === 0
        ) {
          this.props.navigate(PT_ADDRESSLIST.replace(":frompage", "profile"));
          SET_STORE_PAGE_URL(PT_PROFILE);
          return;
        }
      }
      //this.AddressNavgiateBack();
      this.setState({ isLoading: false });
      let pageUrl = await GET_PAGE_URL();
      let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
      const isDtPosOrQr = CSP === "DT" && entryMode === "QR";
      const storedPaymode = ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_PAYMODE);
      const hasStoredPaymode =
        storedPaymode !== undefined &&
        storedPaymode !== null &&
        storedPaymode !== "";
      const shouldReturnToPaymode =
        isDtPosOrQr &&
        (pageUrl === PT_PAYMODE ||
          ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_ORDER) === "1");
      if (shouldReturnToPaymode) {
        if (hasStoredPaymode) {
          const selectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
          const needsAddress = parseInt(selectedDineType) === 4;
          if (
            needsAddress &&
            (dto_CustomerAddress.AddressGuid === undefined ||
              dto_CustomerAddress.AddressGuid === "" ||
              dto_CustomerAddress.AddressGuid === 0)
          ) {
            this.props.navigate(PT_PAYMODE);
            return;
          }
          dto_common.IsCash = parseInt(storedPaymode);
          const bankGuid = ENCRYPT_STORAGE.getItem(STORE_AUTO_PLACE_BANK_GUID);
          ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_ORDER);
          ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_PAYMODE);
          ENCRYPT_STORAGE.removeItem(STORE_AUTO_PLACE_BANK_GUID);
          await placeOrderFromStoredCheckout({
            bankTransferGuid: bankGuid || "",
            navigate: this.props.navigate,
          });
          return;
        }
        this.props.navigate(PT_PAYMODE);
        return;
      }
      if (CSP === "DT" && entryMode === "QR") {
        this.props.navigate(PT_CART);
        return;
      }
      if (pageUrl === undefined || pageUrl === "") {
        this.props.navigate(PT_PROFILE);
      } else {
        this.props.navigate(pageUrl);
        ENCRYPT_STORAGE.removeItem(STORE_PAGE_URL);
      }
    } else {
      // Alert.MessageBox({
      //   Tittle: "Info",
      //   Icon: "error",
      //   ConfirmButtonText: "OK",
      //   Text: "The code you have entered is incorrect ",
      // });

      await ToastMessage(1, "The code you have entered is incorrect ");

      this.setState({ isLoading: false });
      return;
    }
  }

  handleChange = (index, value) => {
    const otp = [...this.state.otp];
    otp[index] = value;
    this.setState({ otp }, () => {
      if (otp.every((digit) => digit !== "")) {
        this.SubmitOTP();
      }
    });
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      this.setState({
        seconds: 0,
        isLoading: false,
      });
      clearInterval(this.timer);
      ENCRYPT_STORAGE.removeItem(TEMP_STORE_OTP);
    }
  }

  AddressNavgiateBack() {
    if (this.props.params.frompage.toUpperCase() === "ORDER") {
      this.props.navigate(PT_ORDERS);
    } else {
      this.props.navigate(PT_PROFILE);
    }
  }

  render() {
    return (
      <>
        <div
          className="otpLayout fadeInUp animated"
          style={{
            height: "100vh",
          }}
        >
          <div
            style={{
              padding: "10px 5px",
              boxShadow:
                CSP === "MK" || CSP === "DT"
                  ? "0px 4px 10px rgba(0, 0, 0, 0.3)"
                  : "",
            }}
          >
            <div>
              {CSP === "MK" || CSP === "DT" ? null : (
                <i
                  className="bi bi-chat-left-dots-fill"
                  style={{ fontSize: "48px", color: Colors.DarkGreyScale }}
                />
              )}
            </div>
            <div className="otpLable" style={{ display: "block" }}>
              Check your inbox!
            </div>
            {CSP === "MK" || CSP === "DT" ? (
              <div
                className="otpText"
                style={{ marginTop: "25px", marginBottom: "20px" }}
              >
                Please enter the OTP which we sent <br /> to{" "}
                <span>+{this.state.PhoneNumber} </span>
                <br />
                <br />
                <div
                  style={{ textDecoration: "underline" }}
                  onClick={() => this.props.navigate(PT_SIGNIN)}
                >
                  Changed your mobile number?
                </div>
              </div>
            ) : (
              <div className="otpText">
                We've sent a four-digit confirmation code to
                <span>+{this.state.PhoneNumber} </span>
                <p>Enter it below to confirm your mobile number</p>
              </div>
            )}

            {CSP === "MK" || CSP === "DT" ? (
              <>
                <div style={{ margin: 10 }} className="otp-group">
                  <input
                    id="OTPSubmit"
                    className="otp-input"
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="one-time-code"
                    maxLength={4}
                    style={{
                      width: "180px",
                      height: "50px",
                      fontSize: "22px",
                      textAlign: "center",
                      letterSpacing: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                    }}
                    placeholder="• • • •"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      e.target.value = value;

                      if (value.length === 4) {
                        this.SubmitOTP();
                      }
                    }}
                    readOnly={this.state.isLoading}
                  />
                </div>
                <input
                  style={{ display: "none" }}
                  id="OTPSubmit"
                  type="tel"
                  value={this.state.otp.join("")}
                />
              </>
            ) : (
              <div style={{ margin: 10 }} className="otp-group">
                <input
                  id="OTPSubmit"
                  className="otp-input"
                  inputMode="numeric"
                  maxLength={4}
                  name="phoneNumber"
                  type="tel"
                  pattern="[0-9]*"
                  autoComplete="tel"
                  style={{ width: "50%", letterSpacing: 10 }}
                  onChange={(e) => {
                    e.currentTarget.value = e.currentTarget.value.replace(
                      /[^0-9]/g,
                      "",
                    );
                    if (e.currentTarget.value.length > 3) {
                      this.SubmitOTP();
                    }
                  }}
                  placeholder="OTP"
                  readOnly={this.state.isLoading}
                />
              </div>
            )}

            {this.state.seconds === 0 ? (
              <button
                className="btnResendOTP"
                style={{ color: "#e38f11" }}
                onClick={() => this.ReSendOTP(this.state.PhoneNumber)}
              >
                Resend OTP
              </button>
            ) : (
              <p
                style={{
                  fontWeight: "bold",
                  justifyContent: "right",
                  display: CSP === "MK" || CSP === "DT" ? "none" : "block",
                }}
              >
                OTP time {this.state.time.m}:{this.state.time.s}s{" "}
              </p>
            )}
            {this.state.isLoading ? (
              <div
                className={
                  CSP !== "MK" && CSP !== "DT" ? "loader" : "newLoader"
                }
                style={{ marginTop: "30%", marginLeft: "45%" }}
              />
            ) : null}
          </div>
        </div>
      </>
    );
  }
}
